import React, { useState } from "react";
import { IconButton, Popover, Box, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";

const CancelReasonPopover = ({ reason }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "cancel-reason-popover" : undefined;

  return (
    <>
      <IconButton size="small" onClick={handleOpen}>
        <VisibilityIcon fontSize="small" />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            p: 1.5,
            maxWidth: 260,
            borderRadius: 2,
            boxShadow: 3,
          },
        }}
      >
        <Box>
          {/* <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Cancellation Reason
          </Typography> */}

          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {reason || "No reason provided"}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default CancelReasonPopover;
